// Words players type that no matching rule can derive from the data. Keyed by
// the exact weapon or unit name in army.json; each alias becomes one more
// searchable word on every row carrying it. Initials of multi-word names
// (hmg, msr, gl) are generated automatically, so only add what they miss.
// Add a line whenever someone searches for something reasonable and gets nothing.

import {SKILL} from '../army/ids.js';

/** @type {Record<string, string[]>} */
export const WEAPON_ALIASES = {
  'Missile Launcher': ['ml'],
  'Heavy Machine Gun': ['hmg'],
  'AP Heavy Machine Gun': ['hmg', 'aphmg'],
  'MULTI Heavy Machine Gun': ['hmg', 'mhmg'],
  'Spitfire': ['spit'],
  'AP Spitfire': ['spit'],
  'Spitfire MULTI': ['spit'],
  'Boarding Shotgun': ['bsg'],
  'T2 Boarding Shotgun': ['bsg'],
  'Light Shotgun': ['lsg'],
  'Heavy Shotgun': ['hsg'],
  'Vulkan Shotgun': ['vsg'],
  'Submachine Gun': ['smg'],
  'AP Submachine Gun': ['smg'],
  'Light Flamethrower': ['lft', 'flamer'],
  'Heavy Flamethrower': ['hft', 'flamer'],
  'Heavy Rocket Launcher': ['hrl'],
  'Light Rocket Launcher': ['lrl'],
  'Hyper-Rapid Magnetic Cannon': ['hmc', 'hrmc'],
  'Portable Autocannon': ['pac'],
  'Marksman Rifle': ['mr'],
  'MULTI Marksman Rifle': ['mmr'],
  'MULTI Sniper Rifle': ['msr'],
  'MULTI Rifle': ['mr', 'multi'],
  'Combi Rifle': ['combi'],
  'K1 Combi Rifle': ['k1'],
  'K1 Sniper Rifle': ['k1'],
  'K1 Marksman Rifle': ['k1'],
  'Plasma Rifle': ['pr'],
  'Plasma Sniper Rifle': ['psr'],
  'Grenade Launcher': ['gl'],
  'Red Fury': ['fury'],
  'MULTI Red Fury': ['fury'],
  'AP Red Fury': ['fury'],
  'Chain Rifle': ['chain'],
  'Nanopulser': ['nano'],
};

/** @type {Record<string, string[]>} */
export const UNIT_ALIASES = {
  // 'Exact ISC from army.json': ['nickname'],
};

// Nicknames for a kind of trooper rather than one unit: a REM with Total
// Reaction is a "TR bot", whatever its name. Matched on profile type and the
// skill id (profile or loadout), so new TR remotes pick it up on their own.
export const KIND_ALIASES = [
  {type: 'REM', skill: SKILL.TOTAL_REACTION, words: ['tr', 'bot', 'bots', 'trbot', 'trbots']},
];

// Skills players search for by name (reactive picks): their ids. The skill's
// name, in the index's language, goes on every loadout with it, from the
// profile or the loadout.
export const SEARCHABLE_SKILLS = [SKILL.TOTAL_REACTION, SKILL.NEUROCINETICS];
